import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "coachingOptions", "zoomSection", "placeSection",
    "dateRangeCheckbox", "dateRangeSection",
    "rsvpLimitCheckbox", "rsvpLimitSection",
    "rsvpMaxCheckbox", "rsvpMaxSection"
  ]

  updateCoachingOptions() {
    const selected = this.coachingOptionsTarget.value

    if (this.hasZoomSectionTarget) {
      this.toggleSection(this.zoomSectionTarget, selected === "zoom")
    }
    if (this.hasPlaceSectionTarget) {
      this.toggleSection(this.placeSectionTarget, selected === "inperson")
    }
  }

  toggleDateRange() {
    const checked = this.dateRangeCheckboxTarget.checked
    this.toggleSection(this.dateRangeSectionTarget, checked)
  }

  toggleRsvpLimit() {
    const checked = this.rsvpLimitCheckboxTarget.checked
    this.toggleSection(this.rsvpLimitSectionTarget, checked)
  }

  toggleRsvpMax() {
    const checked = this.rsvpMaxCheckboxTarget.checked
    this.toggleSection(this.rsvpMaxSectionTarget, checked)
  }

  // Sincroniza visibilidad + estado `disabled` de los inputs internos de la seccion.
  // Disable es obligatorio: si queda enabled con el toggle apagado, el usuario puede
  // editarlo y al guardar el server lo descarta silenciosamente por paridad con React
  // (starts_at/ends_at/rsvp_limit/rsvp_max solo aplican con el toggle activo).
  toggleSection(target, show) {
    target.classList.toggle("hidden", !show)
    target.querySelectorAll("input, select, textarea").forEach(el => {
      el.disabled = !show
    })
  }
}
